import React, {useContext, useEffect, useState} from 'react';
import {useLocation} from 'react-router';

// context api
import AuthContext from '../../authContext';

// material component
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  IconButton,
  DialogActions,
  Divider,
} from '@material-ui/core';
import theme from '../../theme';
import Pagination from '@material-ui/lab/Pagination';

// icons
import Icon from '@mdi/react';
import {mdiCheck, mdiClose, mdiHelp, mdiPencilOutline, mdiPlus} from '@mdi/js';

// components
import Can from '../../components/Can';
import List from './components/list';
import Add from './components/add';
import Modal from '../../components/Modal';

// interfaces & types
import {
  Props,
  SelectorProps,
  AddUnit,
  PayloadCreate,
  editRow,
  PayloadUpdate,
} from './interfaces';

// redux
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {
  getWarehouseZoneUnitAction,
  createUnitActions,
  updateZoneUnitStatusActions,
  editUnitActions,
} from './actions';
import {removeEmptyValueObject} from '../../utils/helpers';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
} from './selectors';
import Edit from './components/edit';

// helpers
import {useQuery} from '../../utils/helpers';

import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';
import warehouseUnitRepository from 'client-sdk/src/Repository/warehouse-unit-repository';

// styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(2, 3),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#B297A7',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    deActiveCenter: {
      position: 'relative',
      marginRight: '30px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#ddd',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },

    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    card: {
      minWidth: '195px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
  })
);

// query selector

const WarehouseZoneUnit: React.FC<Props> = (
  props: Props
): React.ReactElement => {
  const authContext = useContext(AuthContext);
  const [filtersValues, setFiltersValues] = useState({
    warehouseRowId: {equals: +props.match.params.id},
    page: 0,
    size: 10,
  } as any);
  const [openSize, setOpenSize] = useState(false as boolean);
  const [openAddModal, setOpenAddModal] = useState(false as boolean);
  const [zoneData, setZoneData] = useState(null as null | AddUnit);
  const [editZoneData, setEditZoneData] = useState(null as null | editRow);
  const [checkAddZone, setCheckZone] = useState(false as boolean);
  const [checkEditZone, setCheckEditZone] = useState(false as boolean);
  const [openEditModal, setOpenEditModal] = useState(false as boolean);
  const [Id, setId] = useState(-1 as number);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);

  const [warehouseZoneUnits, setWarehouseZoneUnits] = useState([]);
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const classes = useStyles();

  useEffect(() => {
    getWarehouseZoneUnitAction();
  }, [filtersValues]);
  const getWarehouseZoneUnits = async (actions: any) => {
    const payload = {...actions};
    try {
      setLoading(true);
      const {response, count} =
        await warehouseUnitRepository.getWarehouseZoneUnit({payload});
      setWarehouseZoneUnits(response.data);
      setCount(count.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getWarehouseZoneUnitAction = () => {
    const {page, size} = filtersValues;
    getWarehouseZoneUnits({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const handleClose = () => {
    setOpenSize(false);
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const handleCreateUnit = (body: AddUnit) => {
    setZoneData(body);
    setCheckZone(true);
  };

  const handleCloseEditCheck = () => {
    setCheckEditZone(false);
    setEditZoneData(null);
  };
  const updateZoneUnitStatus = async (actions: any) => {
    const payload = {...actions};
    try {
      setLoading(true);
      const pagination = await warehouseUnitRepository.updateZoneUnitStatus({
        payload,
      });
      getWarehouseZoneUnitAction();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleDisableRow = () => {
    updateZoneUnitStatus({
      id: Id,
      body: 'UNAVAILABLE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmDisable(false);
  };
  const handleActiveRow = () => {
    updateZoneUnitStatus({
      id: Id,
      body: 'AVAILABLE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmActive(false);
  };

  const handleCloseCheck = () => {
    setCheckZone(false);
    setZoneData(null);
  };
  const createUnit = async (actions: any) => {
    const payload = {...actions};
    try {
      setLoading(true);
      const {pagination, callback} = await warehouseUnitRepository.createUnit({
        payload,
      });

      callback();
      handleNotfication('یونیت جدید با موفقیت اضافه شد', 'success');
    } catch (error) {
      setError(error.message);
      handleNotfication('مشکلی پیش آمده لطفا دوباره تلاش کنید', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitNewRow = () => {
    const callback = () => {
      setCheckZone(false);
      setOpenAddModal(false);
      setZoneData(null);
      getWarehouseZoneUnitAction();
    };
    const {id} = props.match.params;
    const {unitCount, wastage}: AddUnit = zoneData!;
    createUnit({
      body: {
        // unitCount: +unitCount,
        rowId: +id,
        wastage: wastage,
      },
      pagination: filtersValues,
      callback,
    });
  };

  const editUnitActions = async (actions: any) => {
    const payload = {...actions};
    try {
      setLoading(true);
      const {pagination, callback} = await warehouseUnitRepository.editUnit({
        payload,
      });
      callback();
      handleNotfication('یونیت انتخابی با موفقیت ویرایش شد', 'success');
    } catch (error) {
      setError(error.message);
      handleNotfication('ویرایش یونیت با خطا مواجه شد', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEditRow = () => {
    const callback = () => {
      setCheckEditZone(false);
      setOpenEditModal(false);
      setZoneData(null);
      getWarehouseZoneUnitAction();
    };
    const {id, unitCount}: editRow = editZoneData!;
    editUnitActions({
      body: {
        id: +id,
        unitCount: +unitCount,
      },
      pagination: filtersValues,
      callback,
    });
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };

  const handleOpenEditModal = (id: number) => {
    setId(id);
    setOpenEditModal(true);
  };

  const updateRow = (data: editRow) => {
    setEditZoneData(data);
    setCheckEditZone(true);
  };

  const handleCloseEditModal = () => setOpenEditModal(false);
  return (
    <div className={classes.root}>
      <Grid container justify="space-between" item xs={12} alignItems="center">
        <Grid item>
          <Typography variant="h6" component="h2">
            {`لیست یونیت‌های طبقه ${useQuery(useLocation).get('name')}`}
          </Typography>
        </Grid>
        <Grid item>
          <Can
            role={authContext.user.role}
            perform="warehouse-zone-row:add"
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => {
                  setOpenAddModal(true);
                }}
              >
                تعریف یونیت جدید
              </Button>
            )}
          />
        </Grid>
      </Grid>
      <Box mb={4} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {warehouseZoneUnits.length > 0 ? (
                <List
                  data={warehouseZoneUnits}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  handleOpenConfirmActive={handleOpenConfirmActive}
                  handleOpenEditModal={handleOpenEditModal}
                />
              ) : (
                <Box mt={4}>
                  <Typography variant="h3" component="div">
                    یونیتی موجود نیست
                  </Typography>
                </Box>
              )}
            </>
          )}
          <Box mt={3} />
          {warehouseZoneUnits.length > 0 && (
            <Grid container>
              <Grid item xs={12} sm={6}>
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} sm={6} container item direction="row-reverse">
                <Pagination
                  className={classes.pagination}
                  count={Math.ceil(count / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Modal
        onClose={() => setOpenAddModal(false)}
        open={openAddModal}
        title={
          <div className={classes.addIcon}>
            <Icon path={mdiPlus} size={4} color={theme.palette.green.main} />
          </div>
        }
        content={
          <Add
            onClose={() => setOpenAddModal(false)}
            count={count + 1}
            error={error}
            createUnit={handleCreateUnit}
          />
        }
      />

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        title={
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
        }
        content={
          <Edit
            data={warehouseZoneUnits.find(column => column.id === Id)}
            updateZone={updateRow}
            error={error}
            onClose={handleCloseEditModal}
          />
        }
      />

      <Dialog
        fullWidth
        open={checkAddZone}
        onClose={handleCloseCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseCheck ? (
              <IconButton aria-label="close" onClick={handleCloseCheck}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiHelp} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`آیا از ایجاد کردن یونیت ${zoneData?.name} اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseCheck}
                variant="contained"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleSubmitNewRow}
                fullWidth
                variant="contained"
                size="large"
                color="secondary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  'بله'
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={checkEditZone}
        onClose={handleCloseCheck}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseCheck ? (
              <IconButton aria-label="close" onClick={handleCloseCheck}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.editIcon}>
            <Icon path={mdiHelp} size={4} color={theme.palette.blue.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`آیا از ویرایش کردن یونیت ${
              warehouseZoneUnits.find(unit => unit.id === editZoneData?.id)
                ?.name
            } اطیمنان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseEditCheck}
                variant="contained"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={handleEditRow}
                fullWidth
                variant="contained"
                size="large"
                color="secondary"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} color="secondary" />
                ) : (
                  'بله'
                )}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از

          ${openConfirmDisable ? 'غیر' : ''}

          فعال کردن یونیت با نام
          "${warehouseZoneUnits.find(zone => zone.id === Id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableRow}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  disabled={loading}
                >
                  {'غیرفعال کردن'}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveRow}
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  {loading ? (
                    <CircularProgress size={24} color="secondary" />
                  ) : (
                    'فعال کردن'
                  )}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

// const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
//   warehouseZoneUnits: makeSelectList(),
//   count: makeSelectCountList(),
//   loading: makeSelectLoading(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     warehouseZoneUnitsDispatch: (payload: Record<string, any>) =>
//       dispatch(getWarehouseZoneUnitAction(payload)),
//     createUnitDispatch: (payload: PayloadCreate) =>
//       dispatch(createUnitActions(payload)),
//     updateZoneUnitStatusDispatch: (payload: {
//       id: number;
//       body: string;
//       pagination: object;
//     }) => dispatch(updateZoneUnitStatusActions(payload)),
//     editUnitActions: (payload: PayloadUpdate) =>
//       dispatch(editUnitActions(payload)),
//   };
// }

// const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default WarehouseZoneUnit;
